import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined
} from "@ant-design/icons"
import { Typography } from "antd"
import React from "react"

import type { SaveState } from "./useFormFieldRequirements.ts"

const { Text } = Typography

const LABEL: Record<Exclude<SaveState, "idle">, [React.ReactNode, string]> = {
  pending: [<LoadingOutlined key="pending" />, "Saving…"],
  saving: [<LoadingOutlined key="saving" />, "Saving…"],
  saved: [<CheckCircleOutlined key="saved" />, "All changes saved"],
  error: [<ExclamationCircleOutlined key="error" />, "Not saved"]
}

/** The reassurance an explicit Save button used to give. It keeps the header
 * height stable when nothing has been edited yet, so the Reset button does
 * not shift sideways the first time a field is dropped. */
export function AutosaveStatus({ state }: { state: SaveState }) {
  const entry = state === "idle" ? null : LABEL[state]

  return (
    <Text
      aria-live="polite"
      className="flex min-w-36 items-center justify-end gap-1.5 text-xs"
      type={state === "error" ? "danger" : "secondary"}
    >
      {entry?.[0]}
      {entry?.[1]}
    </Text>
  )
}
